import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { IDispute } from '../interfaces/dispute';
import { IDisputeFilter } from '../interfaces/dispute-filter';
import { IPageResult } from '../interfaces/page-result';
import { ReadService } from './read.service';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';

@Injectable({ providedIn: 'root' })
export class DisputeService extends ReadService<IDispute, IDisputeFilter> {
  url = '/api/disputes';
  entityTitle = 'Dispute';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  addDisputeDetail(body) {
    let successMsg = 'The note is added to the dispute.';
    return this.handleRequest(
      this.http.post('api/disputedetails', body),
      this.handlersFactory.getForUpdate(this.entityTitle),
      successMsg,
    );
  }

  closeDispute(disputeId: number) {
    let successMsg = 'Dispute now marked as resolved.';
    return this.handleRequest(
      this.http.put(this.url + '/close/' + disputeId, {}),
      this.handlersFactory.getForUpdate(this.entityTitle),
      successMsg,
    );
  }

  createDispute(dispute): Promise<any> {
    return this.handleRequest(
      this.http.post(this.url + '/create', dispute),
      this.handlersFactory.getForUpdate(this.entityTitle),
    ).then(this.extractData);
  }

  getTypes(): Promise<any> {
    return this.handleRequest(
      this.http.get(this.url + '/types'),
      this.handlersFactory.getForReadAll(),
    ).then(this.extractData);
  }

  public getPageForJob(jobId: number, filter: IDisputeFilter): Promise<any> {
    let params = this.constructHttpParams(filter);
    return this.handleRequest(
      this.http.get<IPageResult<IDispute>>(this.url + '/job/' + jobId, { params: params }),
      this.handlersFactory.getForReadAll(),
    ).then(this.extractData);
  }

  getAccessDetails(disputeId: number): Promise<any> {
    return this.handleRequest<any>(
      this.http.get<any>(this.url + '/accessDetails/' + disputeId),
      this.handlersFactory.getForReadById(this.entityTitle),
    );
  }
}
